import { Box, WizardStep } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { useActionWizard } from 'modules/processes/components/ItemWizard/Actions/ActionProvider'
import { WizardData } from 'modules/processes/components/ItemWizard/Actions/types'
import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { ActionConfigurationIdentifiers } from 'modules/processes/domain'
import { wizardConfiguredActions } from 'modules/processes/lib/wizardConfiguredActions'

interface Props {
  data: WizardData
  identifier: ActionConfigurationIdentifiers
  onDataChanged: (newData: WizardData) => void
  setTitle: (title: string) => void
}

const FillInformation = ({ data, identifier, onDataChanged, setTitle }: Props) => {
  const components = wizardConfiguredActions()
  const { actions, isActionValid } = useActionWizard()

  const { form, initializeForm } = useFormProvider()

  const currentAction = actions.find((action) => action.identifier === identifier)

  useUnsafeEffect(() => {
    onDataChanged({ ...data, isValid: isActionValid })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActionValid])

  useUnsafeEffect(() => {
    initializeForm(identifier)

    onDataChanged({ ...data })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useUnsafeEffect(() => {
    if (actions) {
      setTitle(data.action?.title || currentAction?.title || '')
    }
  }, [actions])

  const Component = useUnsafeMemo(() => components[identifier]?.editor, [components, identifier])

  if (!form) return null

  if (!Component) return null

  return (
    <Box paddingBottom="s24">
      <Component identifier={identifier} />
    </Box>
  )
}

export const fillInformationStep = (): WizardStep<WizardData> => ({
  title: i18n.t('processes.process_settings.actions.config.steps.set_up'),
  nextText: i18n.t('common.next'),
  render: (props) =>
    props.data.action?.identifier && (
      <FillInformation
        identifier={props.data.action.identifier}
        data={props.data}
        onDataChanged={props.onDataChanged}
        setTitle={props.data.setTitle}
      />
    ),
  isCompleted: (data) => data.isValid,
})
